import secureLocalStorage from "react-secure-storage";
import React from 'react';
import {Navigate, Outlet} from 'react-router-dom';
import * as StorageConstants from '../Models/SecureStorageConstants'
import { clearStoragePreservingBrowserBranding } from '../Template/custom-styling/applyBrowserBranding';

function Protected() {
    let accessTokenAvailable = secureLocalStorage.getItem(StorageConstants.ACCESS_TOKEN) !== null;
    let userAvailable = secureLocalStorage.getItem(StorageConstants.USER) !== null;
    if (!userAvailable || !accessTokenAvailable) {
        clearStoragePreservingBrowserBranding();
    }

    return (
        accessTokenAvailable && userAvailable ?
            <Outlet/> :
            <Navigate to='/sign-in' replace/>
    )
}

export default Protected;